var _path, _rect, _rect2, _rect3, _path2, _rect4, _path3, _rect5, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDocumentation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 96,
    viewBox: "0 0 101 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9446 73.6988C81.9422 68.5658 91.1379 55.8913 91.1379 41.069C91.1379 21.7009 75.437 6 56.069 6C36.7009 6 21 21.7009 21 41.069C21 55.8913 30.1957 68.5659 43.1934 73.6989L56.069 96L68.9446 73.6988Z",
    fill: "#D14547"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.4138,
    y: 31.4482,
    width: 8.68966,
    height: 31.0345,
    fill: "#FFB0B0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4138,
    y: 19.6553,
    width: 8.68966,
    height: 8.68966,
    fill: "#FFB0B0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    width: 35.1998,
    height: 22.3383,
    rx: 5,
    fill: "#FD8087"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6926 11.1694L80.0618 6.18646L80.0618 16.1524L88.6926 11.1694Z",
    fill: "#FFE8E8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 55,
    width: 27,
    height: 18,
    rx: 4,
    fill: "#FD8087"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91 64L85 60.5359L85 67.4641L91 64Z",
    fill: "#FFE8E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 31.2325,
    width: 40.7701,
    height: 25.8734,
    rx: 5,
    fill: "#FD8087"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4419 44.1695L17.4454 38.398L17.4454 49.941L27.4419 44.1695Z",
    fill: "#FFE8E8"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocumentation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/documentation.d71ff7fc.svg";
export { ForwardRef as ReactComponent };